<template>
    <div>
        <div class="main-content">
            <div class="item-box" v-for="item in filterList" :key="item.name">
                <div class="msg-line">
                    <div class="msg-line-left">
                        <img :src="item.src" alt="" />
                        <span>{{ item.title }}</span>
                    </div>
                    <div class="msg-line-right" :style="{'cursor': item.titleClick ? 'pointer' : 'default'}" @click="titleClick(!item.titleClick, item.titlePath)">
                        <div class="num" v-if="item.totalNum > 0">{{ item.totalNum }}</div>
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </div>
                <div class="data-line" v-for="(data, index) in item.list" :key="index">
                    <div class="name-text">
                        {{ data.name }}
                        <span class="product-name" v-if="data.productName">{{ data.productName }}（{{ data.orderTypeStr }}）</span>
                    </div>
                    <div class="tip-waring" :class="{ 'tip-error': item.errorTips }">{{ data.des }}</div>
                </div>
            </div>
            <div class="item-box placeholder" v-for="i in placeholderNum" :key="'p' + i"></div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        dataList: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        filterList() {
            return this.dataList.filter((i) => i.list && i.list.length > 0);
        },
        placeholderNum() {
            return this.dataList.length % 3 > 0 ? 3 - (this.dataList.length % 3) : 0;
        },
    },
    data() {
        return {};
    },
    methods: {
        // 点击标题行右侧的数字跳转
        titleClick(disabled, path) {
            if (disabled) return;
            this.$router.push(path);
        }
    },
};
</script>
<style lang="scss" scoped>
.main-content {
    display: flex;
    flex-wrap: wrap;
    gap: 21px 18px;
    .item-box {
        background-color: #fff;
        border-radius: 12px;
        box-shadow: 0px 1px 0.75rem 1px rgba(4, 32, 93, 0.09);
        padding: 1.38rem;
        min-width: 20rem;
        box-sizing: border-box;
        flex: 1 1 calc(100% / 3 - 10px - 0.75rem);
        .msg-line {
            display: flex;
            justify-content: space-between;
            margin-bottom: 5px;
            .msg-line-left {
                display: flex;
                align-items: center;
                img {
                    width: 1rem;
                    height: 1rem;
                    margin-right: 6px;
                }
                span {
                    font-weight: 550;
                    color: #3366a7;
                }
            }
            .msg-line-right {
                display: flex;
                align-items: center;
                .num {
                    border-radius: 5rem;
                    background-color: #ff0000;
                    color: #fff;
                    font-size: 0.75rem;
                    padding: 0 4px;
                }
            }
        }

        .data-line {
            display: flex;
            justify-content: space-between;
            padding: 0.75rem 0;
            border-bottom: 1px dashed #dddddd;
            .name-text {
                flex: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-right: 0.5rem;
            }
            .product-name {
                margin-left: 0.5rem;
            }
            .tip-waring {
                color: $waring-font-color;
                flex-shrink: 0;
            }
            .tip-error {
                color: $error-font-color;
            }
        }
        .data-line:last-child {
            border-bottom: none;
            padding-bottom: 0;
        }
    }
    /* 去除每行尾的多余边距 */
    .item-box:nth-child(3n) {
        margin-right: 0;
    }
    .placeholder {
        display: none;
    }
}
</style>
